// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3QrVm","rootSmall":"AddTileButton_rootSmall__2al5K"};